import React from 'react'
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import MuiCustomSpeedDial from "../../../../ui/mui/MuiCustomSpeedDial";
import {GiCow} from "react-icons/gi";
import appGARAGEcolors from "../../../../ui/mui/appGARAGEcolors";


type Props = {
    children?: React.ReactNode,
}

function LotsLayout({children}: Props) {
    const navigate = useNavigate();

    const actions = [
        {
            icon: <GiCow/>,
            name: 'Lotti',
            onClick: () => {
                navigate('/apps/tannery_raw_material/lots');
            },
            isPulsing: false,
        },
        {
            icon: <GiCow color={appGARAGEcolors.ACIDGREEN_APPGARAGE_LIGHT}/>,
            name: 'Totali per Forntore',
            onClick: () => {
                navigate('/apps/tannery_raw_material/lots/total_by_supplier');
            },
            isPulsing: false,
        },

    ];


    return (


        <>

            <MuiCustomSpeedDial actions={actions}
                                customIcon={<GiCow color="white" style={{fontSize: 30}}/>}
            />
            <Box sx={{height: 320, transform: 'translateZ(0px)', flexGrow: 1}}>
                {children}
            </Box>


        </>


    );
}

export default LotsLayout